import { AxiosResponse } from 'axios'
import request from '../axios'

export const publishPromissory = async (
    data: any
): Promise<AxiosResponse<any>> => {
    return request.post(
        '/moneypool_management/1111/loan/2500/promissory-publish/',
        data
    )
}

export const signPromissory = async (
    data: any
): Promise<AxiosResponse<any>> => {
    const response = await request.post(
        '/moneypool_management/1111/loan/2500/promissory-sign/',
        data
    )
    return response.data
}

export const deletePromissory = async (
    data: any
): Promise<AxiosResponse<any>> => {
    const response = await request.put(
        '/moneypool_management/1111/loan/2500/promissory-delete/',
        data
    )
    return response.data
}

export const NewStateInquiry = async (
    data: any
): Promise<AxiosResponse<any>> => {
    const response = await request.post(
        '/moneypool_management/1111/loan/2500/promissory-sign-inquiry/',
        data
    )
    return response.data
}

export const getPromissoryNotes = async (): Promise<IPromissory[]> => {
    const response = await request.get<IPromissory[]>(
        'api/v1/promissory/notes/'
    )
    return response.data
}
